import { create } from 'zustand';

const useMiniGamesStore = create((set) => ({
  miniGames: [],
  miniGameListId: null,
  bingoRoomId: null,
  resetBingoRoomId: () => set({ bingoRoomId: null }),
  setBingoRoomId: (newBingoRoomId) =>
    set(() => ({
      bingoRoomId: newBingoRoomId,
    })),
  resetMiniGameListId: () => set({ miniGameListId: null }),
  setMiniGameListId: (newMiniGameListId) =>
    set(() => ({
      miniGameListId: newMiniGameListId,
    })),
  resetMiniGames: () => set({ miniGames: [] }),
  setMiniGames: (newMiniGames) =>
    set(() => ({
      miniGames: newMiniGames,
    })),
}));

export default useMiniGamesStore;
